import { Component, Vue, Prop } from 'vue-property-decorator'

import Loader from '@/components/Loader/index.vue'

import api from '@/helpers/fetch'
import tableHelper from '@/helpers/table'

@Component({
	components: {
		Loader,
	},
})
export default class ModalTrial extends Vue {
	@Prop({ required: true }) trialId
	loading = false

	trial = null

	async loadTrial() {
		this.loading = true
		await this.$nextTick()
		const res = await api.get('/api/trials-adm/' + this.trialId)
		console.log(res)
		this.trial = res.data
		this.loading = false
	}
}
